import { render, staticRenderFns } from "./gc-batch-stock-transfer.vue?vue&type=template&id=34f0dd64"
import script from "./gc-batch-stock-transfer.vue?vue&type=script&lang=js"
export * from "./gc-batch-stock-transfer.vue?vue&type=script&lang=js"
import style0 from "./gc-batch-stock-transfer.vue?vue&type=style&index=0&id=34f0dd64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports